module.exports = __webpack_public_path__ + "images/jobs/mediateurNumeriqueQualite.42e63d70.jpg";